import React from 'react';
import { clsx } from '@pushpay/styles';
import { useMediaBreakpoint } from '@pushpay/theming';
import useStyles from './use-styles';

const HeaderTemplate = ({
  classes: classesProp,
  className: classNameProp,
  mobileMenuButton,
  leftSection,
  toolBar,
  rightSection,
  ...rest
}) => {
  const isTabletAndBelow = useMediaBreakpoint('TABLET_AND_BELOW');
  const classes = useStyles(classesProp);
  const className = clsx(classes.root, classNameProp);
  return /*#__PURE__*/React.createElement("header", Object.assign({
    className: className
  }, rest), isTabletAndBelow && mobileMenuButton && /*#__PURE__*/React.createElement("div", {
    className: classes.mobileMenuButtonWrapper
  }, mobileMenuButton), /*#__PURE__*/React.createElement("div", {
    className: classes.leftSide
  }, leftSection), /*#__PURE__*/React.createElement("div", {
    className: classes.toolBar
  }, toolBar), /*#__PURE__*/React.createElement("div", {
    className: classes.rightSide
  }, rightSection));
};

export default HeaderTemplate;